import { useCallback, useRef } from 'react';

import { logger } from 'utils/logger';

import { useAsyncStateSafeStrictMode } from './useAsyncStateSafeStrictMode';

// SECTION BELOW NEED ONLY FOR DEBUG DURING DEVELOPMENT ------------------------
// const USE_LOADING_TIMEOUT = 'USE_LOADING_TIMEOUT';
// if (IS_DEVELOPMENT) {
//   window.toggleUseLoadingTimeout = () => {
//     if (localStorage.getItem(USE_LOADING_TIMEOUT)) {
//       localStorage.removeItem(USE_LOADING_TIMEOUT);
//     } else {
//       localStorage.setItem(USE_LOADING_TIMEOUT);
//     }
//   };
// }
//
// // eslint-disable-next-line no-unused-vars
// const useThrowOnIdleDEPRECATED = isLoading => {
//   const timeoutIdRef = useRef(null);
//
//   useEffect(() => {
//     if (!localStorage.getItem(USE_LOADING_TIMEOUT)) {
//       return;
//     }
//     if (isLoading) {
//       timeoutIdRef.current = setTimeout(() => {
//         throw new Error(`Loading flag enabled too long`);
//       }, 2 * 60 * 1000);
//     } else if (timeoutIdRef.current) {
//       clearTimeout(timeoutIdRef.current);
//       timeoutIdRef.current = null;
//     }
//   }, [isLoading]);
// };
// END OF DEVELOPMENT SECTION --------------------------------------------------

const useLoading = (isLegacy = false) => {
  const counter = useRef(0);
  const [isLoading, setIsLoadingInner] = useAsyncStateSafeStrictMode(false);

  const setIsLoadingCounter = useCallback(
    value => {
      if (value) {
        counter.current += 1;
        setIsLoadingInner(true);

        return;
      }

      // A stop with no matching start would drive the counter negative, which then
      // poisons the next request (its start moves the counter back to 0 and instantly
      // clears the loading flag). Guard the invariant instead of decrementing below 0.
      if (counter.current === 0) {
        logger.warn('Negative api loader counter');

        return;
      }

      counter.current -= 1;

      if (counter.current === 0) {
        setIsLoadingInner(false);
      }
    },
    [setIsLoadingInner],
  );

  const setIsLoading = !isLegacy ? setIsLoadingCounter : setIsLoadingInner;

  return [isLoading, setIsLoading];
};

export default useLoading;
